// Actions
import * as actions from '../reducers/login/loginActions';
import { storeSession } from '../reducers/auth/authActions';
import { getUser } from '../reducers/user/getUser/getUserActions';
import { push } from 'connected-react-router';

// Selectors
import {
  selectLoginRedirect,
  selectMFAOptions,
} from '../reducers/login/loginSelectors';

const isTimeoutScenario = (body = {}) =>
  body.errorMessage === 'Authentication Error: Authentication timeout.' ||
  body.failureUrl === 'OTP entered has expired';

// Helpers
const loginCompleted = action =>
  action.payload.body &&
  action.payload.body.access_token &&
  action.payload.body.session_token &&
  action.payload.body.refresh_token;

export const LoginListeners = {
  [actions.LOGIN_SUBMITTED]: ({ dispatch, getState }, action) => {
    dispatch(actions.loginStoreData(action.payload));

    //UPDATED: with new flow
    // If login is not completed after device details are sent, then we should continue the login flow with MFA Options
    if (loginCompleted(action)) {
      dispatch(actions.loginSuccess(action.payload));
      return action;
    }

    // If there is only one choice, we should use the default MFA option, otherwise the user should select an option
    const state = getState();
    const MFAOptions = selectMFAOptions(state);
    if (MFAOptions.length === 1) dispatch(actions.UseDefaultMFAOption());
    else
      dispatch(
        actions.loginStoreData({ activeStep: actions.LOGIN_STEPS.MFA_OPTIONS })
      );

    return action;
  },
  [actions.LOGIN_MFA_OPTION_SENT]: ({ dispatch }, action) => {
    dispatch(
      actions.loginStoreData({
        ...action.payload,
        activeStep: actions.LOGIN_STEPS.MFA_CODE,
      })
    );
    return action;
  },
  [actions.LOGIN_MFA_CODE_SENT]: ({ dispatch }, action) => {
    if (loginCompleted(action)) {
      dispatch(actions.loginSuccess(action.payload));
      return action;
    }
    return action;
  },
  [actions.LOGIN_MFA_CODE_RESENT]: ({ dispatch }, action) => {
    dispatch(actions.loginStoreData({ body: action.payload.body }));
    return action;
  },
  [actions.LOGIN_SUCCESS]: ({ dispatch, getState }, action) => {
    const state = getState();
    const redirectLocation = selectLoginRedirect(state);

    dispatch(storeSession(action.payload.body));
    dispatch(getUser());

    if (redirectLocation) dispatch(push(redirectLocation));
    else dispatch(push('/dashboard'));

    return action;
  },
  [actions.LOGIN_FAILURE]: (thunk, action) => {
    // Catch all errors
    return action;
  },
};

const LoginMiddleware = store => next => action => {
  if (LoginListeners[action.type]) {
    if (isTimeoutScenario(action.payload.body)) {
      store.dispatch(actions.loginOTPTimeout());
    } else {
      return next(LoginListeners[action.type](store, action));
    }
  }
  return next(action);
};

export default LoginMiddleware;
